import { decode } from 'jsonwebtoken'
import { acceptPartnerInviteService } from '../api/services/partnerInvite/acceptPartnerInviteService'
import { ModalState } from '../contexts/AuthTypes'

export type AuthTokens = {
  accessToken: string
  refreshToken: string
  expiresIn: number
  refreshExpiresIn?: number
}

type CookieSetter<Name extends string> = (
  name: Name,
  value: unknown,
  options?: { domain?: string }
) => void

type HandleAuthSuccessParams = {
  data: AuthTokens
  cookieDomain: string
  customerUrl: string
  creatorUrl: string
  backofficeUrl: string
  redirectName?: string | null
  inviteToken?: string | null
  setCustomerCookie: CookieSetter<'applaus-auth-customer'>
  setCreatorCookie: CookieSetter<'applaus-auth-creator'>
  setBackofficeCookie: CookieSetter<'applaus-auth-backoffice'>
  setModalState: (modalState: ModalState) => void
  resetAlertModal: () => void
  setLoading: (loading: boolean) => void
}

export const handleAuthSuccess = async ({
  data,
  cookieDomain,
  customerUrl,
  creatorUrl,
  backofficeUrl,
  redirectName,
  inviteToken,
  setCustomerCookie,
  setCreatorCookie,
  setBackofficeCookie,
  setModalState,
  resetAlertModal,
  setLoading
}: HandleAuthSuccessParams) => {
  const decoded = decode(data.accessToken)

  if (!decoded || typeof decoded === 'string') {
    setLoading(false)
    return
  }

  switch (decoded.type) {
    case 'CUSTOMER':
      setCustomerCookie(
        'applaus-auth-customer',
        {
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
          expiresIn: data.expiresIn
        },
        { domain: cookieDomain }
      )
      setTimeout(() => {
        if (redirectName) {
          window.location.href = redirectName
        } else {
          window.location.href = customerUrl
        }
      }, 3000)
      break
    case 'CREATOR':
      setCreatorCookie(
        'applaus-auth-creator',
        {
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
          expiresIn: data.expiresIn
        },
        { domain: cookieDomain }
      )
      if (inviteToken) {
        try {
          await acceptPartnerInviteService(inviteToken, data.accessToken)
        } catch {
          setModalState({
            buttonText: 'Continuar',
            click: () => {
              resetAlertModal()
              window.location.href = creatorUrl
            },
            message:
              'Login realizado, mas não foi possível aceitar o convite de produtor. Tente novamente pelo link do e-mail.',
            open: true,
            variant: 'error'
          })
          setLoading(false)
          return
        }
      }
      window.location.href = creatorUrl
      break
    case 'BACKOFFICE':
      setBackofficeCookie(
        'applaus-auth-backoffice',
        {
          refreshToken: data.refreshToken
        },
        { domain: cookieDomain }
      )
      window.location.href = backofficeUrl
      break
    default:
      break
  }

  setLoading(false)
}
